/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import TextError from "utils/TextError";
import * as Yup from "yup";

// Date fns
import { addMinutes, format } from "date-fns";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { CSVLink } from "react-csv";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  createDynamicColumn,
  createProductionPlan,
  deleteProductionPlan,
  editRequiredQty,
  getDynamicColumn,
  getItemMaster,
  getProductionPlan,
  getProductionPlanDownload,
  getSubModulesByRoleId,
  publishProductionPlan,
  uploadForProductionPlan,
} from "../../../store";

// React-Select component and styling
import Select from "react-select";
import "../../../index.css";

// config file
import Config from "../../../config/index";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import EditButton from "components/standardized-components/EditButton";
import UploadButton from "components/standardized-components/UploadButton";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: "fit-content",
  maxHeight: "90%",
  overflow: "auto",
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForRelease = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const UnpublishedProductionPlan = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  createProductionPlan,
  editRequiredQty,
  deleteProductionPlan,
  publishProductionPlan,
  uploadForProductionPlan,
  getProductionPlan,
  getProductionPlanReducer,
  getProductionPlanDownload,
  getProductionPlanDownloadReducer,
  itemMaster,
  getItemMaster,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;

  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);
  const [uncheck, setUncheck] = useState(false);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const subModuleId = "5b97b40b-9a98-4bd7-86e8-494a7c11637b";

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  let productionPlanModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "5b97b40b-9a98-4bd7-86e8-494a7c11637b",
  );
  let createAccess = productionPlanModule
    ? productionPlanModule.actionId.includes(
        "13b77e27-e61a-4bf1-aa63-28eb167322c2",
      )
    : null;
  let viewAccess = productionPlanModule
    ? productionPlanModule.actionId.includes(
        "2069c8fc-320d-4201-8416-5b6c99df995f",
      )
    : null;
  let uploadAccess = productionPlanModule
    ? productionPlanModule.actionId.includes(
        "4505a931-a0c8-471a-905c-f272cfebf5bf",
      )
    : null;
  let downloadAccess = productionPlanModule
    ? productionPlanModule.actionId.includes(
        "128ef9ab-9747-4ee7-b785-8cdc8f0f0888",
      )
    : null;
  let editAccess = productionPlanModule
    ? productionPlanModule.actionId.includes(
        "b304c6af-63c0-4bdf-81b4-3ed4aa6deb8a",
      )
    : null;
  let deleteAccess = productionPlanModule
    ? productionPlanModule.actionId.includes(
        "c2b03a56-8517-460e-b2d6-ac19cf53e99a",
      )
    : null;
  let publishAccess = productionPlanModule
    ? productionPlanModule.actionId.includes(
        "2e62e225-831a-4508-b728-52aa8050ea9f",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  useEffect(() => {
    viewAccess &&
      getProductionPlan(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewAccess, pageNo, rowsPerPage, searchObject]);
  useEffect(() => {
    getProductionPlanDownload(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject]);

  const [state, setState] = useState({
    columns: [
      // { Header: "Part Code/Description", accessor: "partDesc" },
      { Header: "Item Code", accessor: "itemCode" },
      {
        Header: "Purchase Date",
        accessor: "date",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy",
              )
            : "";
        },
      },
      // { Header: "po number", accessor: "purchaseOrderNumber" },
      // { Header: "po line number", accessor: "purchaseOrderLineNumber" },
      { Header: "Qty", accessor: "qty" },
      { Header: "Unloading Point", accessor: "unloadingPoint" },
      { Header: "Delivery Plant", accessor: "deliveryPlant" },
      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [isErrorForCreate, setIsErrorForCreate] = useState(false);
  const [isSuccessForCreate, setIsSuccessForCreate] = useState(false);

  useEffect(() => {
    if (isErrorForCreate) {
      setTimeout(() => {
        setIsErrorForCreate(false);
      }, 3000);
    }
  }, [isErrorForCreate]);

  useEffect(() => {
    if (isSuccessForCreate) {
      setTimeout(() => {
        setIsSuccessForCreate(false);
      }, 3000);
    }
  }, [isSuccessForCreate]);

  const [loading, setLoading] = useState(true);
  const [download, setDownload] = useState("");

  useEffect(() => {
    let tempAsset = [];
    let data = getProductionPlanReducer.production.data
      ? getProductionPlanReducer.production.data
      : [];

    setLoading(getProductionPlanReducer.loading);
    setPaginationObj(getProductionPlanReducer?.production?.pagination);
    data.map((plans) => {
      const formatDate = new Date(plans.date);

      const plansObject = {
        privateKey: plans.productionPlanId,
        date: plans.date,
        // date: format(
        //   addMinutes(formatDate, formatDate.getTimezoneOffset()),
        //   "do MMMM yyyy"
        // ),
        qty: plans.qty,
        productionPlanId: plans.productionPlanId,
        isPublished: plans.isPublished,
        purchaseOrderNumber: plans.purchaseOrderNumber,
        purchaseOrderLineNumber: plans.purchaseOrderLineNumber,
        itemCode: plans.itemCode,
        unloadingPoint:
          plans.unloadingPoint == "undefined" ? "NA" : plans.unloadingPoint,
        deliveryPlant:
          plans.deliveryPlant == "undefined" ? "NA" : plans.deliveryPlant,

        isEditable: plans.isEditable,
        action: (
          <div>
            {editAccess && (
              <EditButton
                tooltip="Edit"
                disabled={plans.isPublished === 1}
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateProductionModal(plans)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                disabled={plans.isPublished === 1}
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(plans)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
          </div>
        ),
      };
      tempAsset.push(plansObject);
    });

    setState({ ...state, rows: tempAsset });
  }, [getProductionPlanReducer]);

  useEffect(() => {
    let tempAsset = [];
    let data = getProductionPlanDownloadReducer.production.data
      ? getProductionPlanDownloadReducer.production.data
      : [];
    console.log("data", data);
    data.map((plans) => {
      const formatDate = new Date(plans.date);

      const plansObject = {
        privateKey: plans.productionPlanId,
        // date: plans.date,
        date: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "do MMMM yyyy",
        ),
        qty: plans.qty,
        productionPlanId: plans.productionPlanId,
        isPublished: plans.isPublished,
        purchaseOrderNumber: plans.purchaseOrderNumber,
        purchaseOrderLineNumber: plans.purchaseOrderLineNumber,
        itemCode: plans.itemCode,
        unloadingPoint:
          plans.unloadingPoint == "undefined" ? "NA" : plans.unloadingPoint,
        deliveryPlant:
          plans.deliveryPlant == "undefined" ? "NA" : plans.deliveryPlant,

        isEditable: plans.isEditable,
        action: (
          <div>
            {editAccess && (
              <EditButton
                tooltip="Edit"
                disabled={plans.isPublished === 1}
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateProductionModal(plans)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                disabled={plans.isPublished === 1}
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(plans)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
          </div>
        ),
      };
      tempAsset.push(plansObject);
    });
    setDownload(tempAsset);
  }, [getProductionPlanDownloadReducer]);

  const [openCreateProductionModal, setOpenCreateProductionModal] =
    useState(false);

  const handleOpenCreateProductionModal = () => {
    setOpenCreateProductionModal(true);
    formikForCreateProductionPlan.setValues(initialValueForCreateProduction);
    formikForCreateProductionPlan.setTouched({});
    formikForCreateProductionPlan.setErrors({});
    setSelectedItemCode("");
    getItemMaster(jwtToken);
  };

  const handleCloseCreateProductionModal = () => {
    setOpenCreateProductionModal(false);
  };

  const initialValueForCreateProduction = {
    // partCodeDes: "",
    purchaseDate: "",
    itemCode: "",
    reqQty: "",
  };
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set to start of the day
  const todayStr = today.toISOString().split("T")[0];

  const validationSchemaForProduction = Yup.object({
    // purchaseOrderNumber: Yup.string().required("Enter purchase order number"),
    // purchaseOrderLineNumber: Yup.string().required(
    //   "Enter purchase order line number"
    // ),
    unloadingPoint: Yup.string().required("Enter unloading point"),
    deliveryPlant: Yup.string().required("Enter delivery plant"),
    purchaseDate: Yup.date()
      .min(today, "Date cannot be in the past!")
      .required("Select a valid date"),
    itemCode: Yup.object().required("Select item Code"),
    reqQty: Yup.string().required("Enter a qty"),
  });

  const [buttonName, setButtonName] = useState("Create");

  const onSubmitForCreateProduction = async (values, { resetForm }) => {
    setButtonName("Please wait...");
    let payload = {
      // partCodeDes: values.partCodeDes,
      date: values.purchaseDate,
      userId: userId,
      qty: values.reqQty,
      unloadingPoint: values.unloadingPoint,
      deliveryPlant: values.deliveryPlant,
      purchaseOrderNumber: values.purchaseOrderNumber,
      purchaseOrderLineNumber: values.purchaseOrderLineNumber,
      // itemCode: selectedItemCode?.label,
      itemId: selectedItemCode?.value,
      itemCode: selectedItemCode?.code,
    };

    let res = await createProductionPlan(payload, jwtToken);

    if (res.status) {
      setIsSuccessForCreate(true);
      getProductionPlan(pageNo, rowsPerPage, searchObject, jwtToken);
      setSelectedItemCode("");

      setTimeout(() => {
        setButtonName("Create");
      }, 2250);
      resetForm();
    }
    if (!res.status) {
      setIsErrorForCreate(true);
      setErrorMsgForCreate(res?.data?.data?.msg);
      setButtonName("Create");
    }
  };

  const formikForCreateProductionPlan = useFormik({
    initialValues: initialValueForCreateProduction,
    validationSchema: validationSchemaForProduction,
    onSubmit: onSubmitForCreateProduction,
  });
  const [singleProductionDataForPublish, setSingleProductionDataForPublish] =
    useState({});

  const [singleProductionDataForDelete, setSingleProductionDataForDelete] =
    useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (plans = {}) => {
    setSingleProductionDataForDelete(plans);

    setOpenDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const [isErrorDelete, setIsErrorDelete] = useState(false);
  const [isSuccessDelete, setIsSuccessDelete] = useState(false);

  useEffect(() => {
    if (isErrorDelete) {
      setTimeout(() => {
        setIsErrorDelete(false);
      }, 3000);
    }
  }, [isErrorDelete]);

  useEffect(() => {
    if (isSuccessDelete) {
      setTimeout(() => {
        setIsSuccessDelete(false);
      }, 3000);
    }
  }, [isSuccessDelete]);
  const [isErrorPublish, setIsErrorPublish] = useState(false);
  const [isSuccessPublish, setIsSuccessPublish] = useState(false);
  const [isErrorMsgForPublish, setIsErrorMsgForPublish] = useState(false);

  useEffect(() => {
    if (isErrorPublish) {
      setTimeout(() => {
        setIsErrorPublish(false);
      }, 3000);
    }
  }, [isErrorPublish]);

  useEffect(() => {
    if (isSuccessPublish) {
      setTimeout(() => {
        setIsSuccessPublish(false);
      }, 3000);
    }
  }, [isSuccessPublish]);

  const [deleteButtonName, setdeleteButtonName] = useState("Delete");

  const deleteProductionData = async () => {
    setdeleteButtonName("Please wait...");
    let productionPlanId = singleProductionDataForDelete.productionPlanId;

    let response = await deleteProductionPlan(
      productionPlanId,
      userId,
      jwtToken,
    );
    if (response.status) {
      setIsSuccessDelete(true);
      getProductionPlan(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseDeleteModal();
        setdeleteButtonName("Delete");
      }, 2250);
    }
    if (!response.status) {
      setIsErrorDelete(true);
      setErrorMsgForDelete(response?.data?.data?.msg);
      setdeleteButtonName("Delete");
    }
  };

  const [openCreatePublishModal, setOpenCreatePublishModal] = useState(false);

  const [selectedPublishData, setSelectedPublishData] = useState([]);

  const handleOpenCreatePublishModal = (data = {}) => {
    setOpenCreatePublishModal(true);
  };

  const handleCloseCreatePickupListModal = () => {
    setOpenCreatePublishModal(false);
  };

  const createPublishHandler = (event, data) => {
    handleOpenCreatePublishModal(data);
  };

  const PublishData = (data) => {
    setSelectedPublishData(data);
  };

  const [publishButtonName, setPublishButtonName] = useState("Publish");

  const onClickReleaseProduction = async () => {
    setPublishButtonName("Please wait...");
    let payload = [];

    selectedPublishData.map((data) => {
      const tempPayload = {
        productionPlanId: data.productionPlanId,
      };
      payload.push(tempPayload);
    });
    let res = await publishProductionPlan(payload, jwtToken);

    if (res.status) {
      setUncheck(!uncheck);
      getProductionPlan(pageNo, rowsPerPage, searchObject, jwtToken);
      setIsSuccessPublish(true);
      setTimeout(() => {
        handleCloseCreatePickupListModal();
        setPublishButtonName("Publish");
      }, 2000);
    }
    if (!res.status) {
      setIsErrorPublish(true);
      setIsErrorMsgForPublish(res?.data?.data?.msg);
      setPublishButtonName("Publish");
    }
  };

  const [disableButton, setDisableButton] = useState(false);

  useEffect(() => {
    let value = selectedPublishData.some((data) => data.isPublished === 1);
    setDisableButton(value);
  }, [selectedPublishData]);

  const [openUpdateProductionModal, setOpenUpdateProductionModal] =
    useState(false);
  const [singleProductionDataForUpdate, setProductionDataForUpdate] = useState(
    {},
  );
  const handleOpenUpdateProductionModal = (Asset = {}) => {
    setProductionDataForUpdate(Asset);
    setOpenUpdateProductionModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateProductionModal = () => {
    setOpenUpdateProductionModal(false);
    formikForUpdate.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 4000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    reqQty: singleProductionDataForUpdate.qty,
    eDate: singleProductionDataForUpdate.date?.slice(0, 10),
  };
  // const today = new Date();
  // today.setHours(0, 0, 0, 0); // Set to start of the day
  // const todayStr = today.toISOString().split('T')[0];

  const validationSchemaForUpdate = Yup.object({
    eDate: Yup.date().min(today, "Date cannot be in the past!"),
    // .required("Enter the asset name!"),
  });
  //   const validationSchemaForUpdate = Yup.object({
  //     eDate: Yup.string().required("Enter the asset name!"),
  //     assetCode: Yup.string().required("Enter the asset code!"),
  //   });

  const [editButtonName, setEditButtonName] = useState("Submit");

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    let payload = {
      productionPlanId: singleProductionDataForUpdate.productionPlanId,
      qty: values.reqQty,
      date: values.eDate,
      userId: userId,
    };

    let res = await editRequiredQty(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getProductionPlan(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        setEditButtonName("Submit");
      }, 2250);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Submit");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);

  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };

  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    let data = new FormData();

    data.append("userId", userId);
    data.append("production", uploadCsvData);

    let res = await uploadForProductionPlan(data, jwtToken);

    if (res.status) {
      getProductionPlan(pageNo, rowsPerPage, searchObject, jwtToken);
      setUploadCsvFilter(false);
      DataUploadSuccessNotification();
    }
    if (!res.status) {
      DataUploadFailureNotification(res?.data?.data?.msg);
    }
  };

  const headers = [
    {
      label: "date",
      key: "date",
    },
    // {
    //   label: "purchaseOrderNumber",
    //   key: "purchaseOrderNumber",
    // },
    // {
    //   label: "purchaseOrderLineNumber",
    //   key: "purchaseOrderLineNumber",
    // },
    {
      label: "itemCode",
      key: "itemCode",
    },
    { label: "qty", key: "qty" },

    { label: "unloadingPoint", key: "unloadingPoint" },
    { label: "deliveryPlant", key: "deliveryPlant" },
  ];
  const csvLink = {
    filename: "Production Plan Template.csv",
    headers: headers,
    data: [],
  };
  const csvLink2 = {
    filename: "Production Plan.csv",
    headers: headers,
    data: download,
  };
  console.log("download", download);
  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
        code: item.itemCode,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getProductionPlan(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <div>
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {/* {createAssetAccess && ( */}

              <MDBox color="text" px={2} ml={-2} mb={1}>
                {createAccess && (
                  <CreateButton
                    tooltip="Create Production Plan"
                    color="info"
                    variant="contained"
                    type="button"
                    onClick={handleOpenCreateProductionModal}
                    style={{ marginRight: "10px" }}
                    iconOnly
                  >
                    <Icon>add</Icon>
                  </CreateButton>
                )}

                <CSVLink {...csvLink}>
                  <DownloadButton
                    tooltip="Download Template"
                    style={{ marginRight: "0.5rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                </CSVLink>

                {uploadAccess && (
                  <UploadButton
                    tooltip="Upload Production Plan"
                    style={{ marginRight: "0.5rem" }}
                    type="button"
                    variant="outlined"
                    color="info"
                    iconOnly
                    onClick={uploadCsvFilterHandler}
                  >
                    <Icon>upload</Icon>
                  </UploadButton>
                )}

                <CSVLink {...csvLink2}>
                  {downloadAccess && (
                    <DownloadDataButton
                      tooltip="Download Production Plan List"
                      style={{ marginRight: "1rem" }}
                      type="button"
                      variant="outlined"
                      color="success"
                      iconOnly
                    >
                      <Icon>download</Icon>
                    </DownloadDataButton>
                  )}
                </CSVLink>
              </MDBox>

              {uploadCsvFilter && (
                <div>
                  <div>
                    <input
                      className="choose_file"
                      style={{
                        // marginTop: "1.5rem",
                        marginLeft: "1.5rem",
                        // marginBottom: "-9rem",
                      }}
                      type="file"
                      accept=".csv"
                      onChange={(e) => {
                        setUploadCsvData(e.target.files[0]);
                      }}
                    />

                    <MDButton
                      disabled={
                        !uploadCsvData?.name ||
                        uploadCsvData?.type !== "text/csv"
                      }
                      variant="contained"
                      color="info"
                      style={{ marginLeft: "0", marginTop: "0rem" }}
                      type="button"
                      onClick={uploadCsvHandler}
                    >
                      UPLOAD
                    </MDButton>
                  </div>
                  <div>
                    <span
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginLeft: "30px",
                        fontStyle: "italic",
                      }}
                    >
                      <strong>*</strong> Please upload
                      <strong>".csv"</strong> file only
                    </span>
                  </div>
                </div>
              )}

              <MDBox mt={0}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted
                  tableSearch
                  showTotalEntries
                  noEndBorder
                  loading={loading}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  serverSidePagination
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  /* Table options */
                  options={{ draggable: false }}
                  /* Column reorder */
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  /* Meta */
                  subModuleId={subModuleId}
                  userId={userId}
                  hideColumns={["", "unloadingPoint", "deliveryPlant"]}
                  selectionButtonComponent={
                    // createPickuplistAccess &&
                    <Tooltip title="Publish">
                      {publishAccess && (
                        <MDButton
                          disabled={disableButton}
                          color="white"
                          type="button"
                          style={{
                            marginTop: "0.5rem",
                            color: "white",
                            border: "1px solid #0275d8",
                            background: "#0275d8",
                            marginLeft: 5,
                          }}
                          onClick={(evt, data) =>
                            createPublishHandler(evt, data)
                          }
                        >
                          Publish
                        </MDButton>
                      )}
                      {/* {disableButton && publishAccess && (
                          <MDTypography
                            color="error"
                            variant="p"
                            style={{
                              // textAlign: "center",
                              marginLeft: "1rem",
                              marginTop: "1rem",
                            }}
                          >
                            Remove the published records!
                          </MDTypography>
                        )} */}
                    </Tooltip>
                  }
                />
              </MDBox>
              <Modal
                open={openCreateProductionModal}
                onClose={handleCloseCreateProductionModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Create Production Plan
                    </MDTypography>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseCreateProductionModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForCreateProductionPlan.handleSubmit}
                    >
                      <MDBox>
                        <MDBox mb={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Purchase Date
                          </MDTypography>
                          <MDInput
                            type="date"
                            name="purchaseDate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForCreateProductionPlan.handleBlur}
                            onChange={
                              formikForCreateProductionPlan.handleChange
                            }
                            value={
                              formikForCreateProductionPlan.values.purchaseDate
                            }
                            error={
                              formikForCreateProductionPlan.touched
                                .purchaseDate &&
                              formikForCreateProductionPlan.errors
                                .purchaseDate &&
                              true
                            }
                          />
                          {formikForCreateProductionPlan.touched.purchaseDate &&
                            formikForCreateProductionPlan.errors
                              .purchaseDate && (
                              <TextError
                                msg={
                                  formikForCreateProductionPlan.errors
                                    .purchaseDate
                                }
                              />
                            )}
                        </MDBox>
                        {/* <MDBox mb={1}>
                          <div style={{ display: "flex" }}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              PO Number
                            </MDTypography>
                          </div>
                          <MDInput
                            type="text"
                            name="purchaseOrderNumber"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForCreateProductionPlan.handleBlur}
                            onChange={
                              formikForCreateProductionPlan.handleChange
                            }
                            value={
                              formikForCreateProductionPlan.values
                                .purchaseOrderNumber
                            }
                            error={
                              formikForCreateProductionPlan.touched
                                .purchaseOrderNumber &&
                              formikForCreateProductionPlan.errors
                                .purchaseOrderNumber &&
                              true
                            }
                          />
                          {formikForCreateProductionPlan.touched
                            .purchaseOrderNumber &&
                            formikForCreateProductionPlan.errors
                              .purchaseOrderNumber && (
                              <TextError
                                msg={
                                  formikForCreateProductionPlan.errors
                                    .purchaseOrderNumber
                                }
                              />
                            )}
                        </MDBox>
                        <MDBox mb={1}>
                          <div style={{ display: "flex" }}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              PO Line Number
                            </MDTypography>
                          </div>
                          <MDInput
                            type="text"
                            name="purchaseOrderLineNumber"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForCreateProductionPlan.handleBlur}
                            onChange={
                              formikForCreateProductionPlan.handleChange
                            }
                            value={
                              formikForCreateProductionPlan.values
                                .purchaseOrderLineNumber
                            }
                            error={
                              formikForCreateProductionPlan.touched
                                .purchaseOrderLineNumber &&
                              formikForCreateProductionPlan.errors
                                .purchaseOrderLineNumber &&
                              true
                            }
                          />
                          {formikForCreateProductionPlan.touched
                            .purchaseOrderLineNumber &&
                            formikForCreateProductionPlan.errors
                              .purchaseOrderLineNumber && (
                              <TextError
                                msg={
                                  formikForCreateProductionPlan.errors
                                    .purchaseOrderLineNumber
                                }
                              />
                            )}
                        </MDBox> */}
                        <MDBox style={{ width: "300px" }}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Item Code/Des
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css-for-itemcode"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="itemCode"
                            onBlur={() => {
                              formikForCreateProductionPlan.handleBlur({
                                target: { name: "itemCode" },
                              });
                            }}
                            value={selectedItemCode}
                            options={itemCodeOptions}
                            onChange={(selectedOption) => {
                              handleItemCodeChange(selectedOption);
                              formikForCreateProductionPlan.setFieldValue(
                                "itemCode",
                                selectedOption,
                              );
                            }}
                          />

                          {formikForCreateProductionPlan.touched.itemCode &&
                            formikForCreateProductionPlan.errors.itemCode && (
                              <TextError
                                msg={
                                  formikForCreateProductionPlan.errors.itemCode
                                }
                              />
                            )}
                        </MDBox>

                        <MDBox mb={1}>
                          <div style={{ display: "flex" }}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Required Qty
                            </MDTypography>
                          </div>
                          <MDInput
                            type="number"
                            name="reqQty"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForCreateProductionPlan.handleBlur}
                            onChange={
                              formikForCreateProductionPlan.handleChange
                            }
                            value={formikForCreateProductionPlan.values.reqQty}
                            error={
                              formikForCreateProductionPlan.touched.reqQty &&
                              formikForCreateProductionPlan.errors.reqQty &&
                              true
                            }
                          />
                          {formikForCreateProductionPlan.touched.reqQty &&
                            formikForCreateProductionPlan.errors.reqQty && (
                              <TextError
                                msg={
                                  formikForCreateProductionPlan.errors.reqQty
                                }
                              />
                            )}
                        </MDBox>
                        <MDBox mb={1}>
                          <div style={{ display: "flex" }}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Unloading Point
                            </MDTypography>
                          </div>
                          <MDInput
                            type="text"
                            name="unloadingPoint"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForCreateProductionPlan.handleBlur}
                            onChange={
                              formikForCreateProductionPlan.handleChange
                            }
                            value={
                              formikForCreateProductionPlan.values
                                .unloadingPoint
                            }
                            error={
                              formikForCreateProductionPlan.touched
                                .unloadingPoint &&
                              formikForCreateProductionPlan.errors
                                .unloadingPoint &&
                              true
                            }
                          />
                          {formikForCreateProductionPlan.touched
                            .unloadingPoint &&
                            formikForCreateProductionPlan.errors
                              .unloadingPoint && (
                              <TextError
                                msg={
                                  formikForCreateProductionPlan.errors
                                    .unloadingPoint
                                }
                              />
                            )}
                        </MDBox>
                        <MDBox mb={1}>
                          <div style={{ display: "flex" }}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Delivery Plant
                            </MDTypography>
                          </div>
                          <MDInput
                            type="text"
                            name="deliveryPlant"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForCreateProductionPlan.handleBlur}
                            onChange={
                              formikForCreateProductionPlan.handleChange
                            }
                            value={
                              formikForCreateProductionPlan.values.deliveryPlant
                            }
                            error={
                              formikForCreateProductionPlan.touched
                                .deliveryPlant &&
                              formikForCreateProductionPlan.errors
                                .deliveryPlant &&
                              true
                            }
                          />
                          {formikForCreateProductionPlan.touched
                            .deliveryPlant &&
                            formikForCreateProductionPlan.errors
                              .deliveryPlant && (
                              <TextError
                                msg={
                                  formikForCreateProductionPlan.errors
                                    .deliveryPlant
                                }
                              />
                            )}
                        </MDBox>
                        <MDBox mt={2}>
                          <Collapse in={isSuccessForCreate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsSuccessForCreate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Plan created successfully!
                            </Alert>
                          </Collapse>
                          <Collapse in={isErrorForCreate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForCreate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {/* Could not create the Asset! */}
                              {errorMsgForCreate}
                            </Alert>
                          </Collapse>
                        </MDBox>

                        <div className="mt-3">
                          <MDButton
                            type="submit"
                            variant="gradient"
                            color="info"
                            fullWidth
                            disabled={
                              !formikForCreateProductionPlan.isValid ||
                              buttonName === "Please wait..."
                            }
                          >
                            {buttonName}
                          </MDButton>
                        </div>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={openCreatePublishModal}
                onClose={handleCloseCreatePickupListModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForRelease}>
                  <MDTypography>
                    Are you sure you want to Publish ?
                  </MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      // style={{ width: "48%", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreatePickupListModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ marginLeft: "0.5rem" }}
                      color="info"
                      onClick={onClickReleaseProduction}
                      disabled={publishButtonName === "Please wait..."}
                    >
                      {publishButtonName}
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessPublish}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessPublish(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Published successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorPublish}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorPublish(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForPublish}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={openUpdateProductionModal}
                onClose={handleCloseUpdateProductionModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Update
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseUpdateProductionModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForUpdate.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography variant="h6"> Qty</MDTypography>
                        <MDInput
                          type="number"
                          name="reqQty"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForUpdate.handleBlur}
                          onChange={formikForUpdate.handleChange}
                          value={formikForUpdate.values.reqQty}
                          error={
                            formikForUpdate.touched.reqQty &&
                            formikForUpdate.errors.reqQty &&
                            true
                          }
                          inputProps={{
                            maxLength: 45,
                          }}
                        />
                        {formikForUpdate.touched.reqQty &&
                          formikForUpdate.errors.reqQty && (
                            <TextError msg={formikForUpdate.errors.reqQty} />
                          )}
                      </MDBox>
                      <MDBox mb={2}>
                        <MDTypography variant="h6"> Date</MDTypography>
                        <MDInput
                          type="date"
                          name="eDate"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForUpdate.handleBlur}
                          onChange={formikForUpdate.handleChange}
                          value={formikForUpdate.values.eDate}
                          error={
                            formikForUpdate.touched.eDate &&
                            formikForUpdate.errors.eDate &&
                            true
                          }
                          inputProps={{
                            maxLength: 45,
                          }}
                        />
                        {formikForUpdate.touched.eDate &&
                          formikForUpdate.errors.eDate && (
                            <TextError msg={formikForUpdate.errors.eDate} />
                          )}
                      </MDBox>
                      <MDBox>
                        <Collapse in={isErrorForUpdate}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsgForUpdate}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Updated successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDButton
                          variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={
                            !formikForUpdate.isValid ||
                            editButtonName === "Please wait..."
                          }
                        >
                          {editButtonName}
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openDeleteModal}
                onClose={handleCloseDeleteModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={deleteStyle}>
                  <MDTypography>Are you sure you want to delete?</MDTypography>
                  <MDBox mt={2} display="flex">
                    <div>
                      <MDButton
                        style={{ width: "100%", marginRight: "0.5rem" }}
                        color="info"
                        variant="outlined"
                        onClick={handleCloseDeleteModal}
                      >
                        Cancel
                      </MDButton>
                    </div>
                    <div style={{ float: "right" }}>
                      <MDButton
                        style={{ width: "100%", marginLeft: "0.5rem" }}
                        color="error"
                        onClick={deleteProductionData}
                        disabled={deleteButtonName === "Please wait..."}
                      >
                        {deleteButtonName}
                      </MDButton>
                    </div>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessDelete}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessDelete(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorDelete}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDelete(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getProductionPlanReducer: state.getProductionPlanReducer,
    getProductionPlanDownloadReducer: state.getProductionPlanDownloadReducer,
    // profileData: state.profile,
    itemMaster: state.itemMaster,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getProductionPlan: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getProductionPlan(pageNo, rowsPerPage, searchObject, jwtToken)),
    getProductionPlanDownload: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getProductionPlanDownload(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    deleteProductionPlan: (productionPlanId, userId, jwtToken) =>
      dispatch(deleteProductionPlan(productionPlanId, userId, jwtToken)),
    publishProductionPlan: (payload, jwtToken) =>
      dispatch(publishProductionPlan(payload, jwtToken)),
    createProductionPlan: (payload, jwtToken) =>
      dispatch(createProductionPlan(payload, jwtToken)),
    editRequiredQty: (payload, jwtToken) =>
      dispatch(editRequiredQty(payload, jwtToken)),
    uploadForProductionPlan: (payload, jwtToken) =>
      dispatch(uploadForProductionPlan(payload, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),

    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UnpublishedProductionPlan);
